import axios from '@/util/axios'
import axiosNoError from '@/util/axios_no_error'
import { NEW_API_CONFIG } from '@/util/constants'
import { isFromAdminSystem } from '@/util/common'
import store from '@/store'
import { handleApiError as handleError } from '@/util/axios_common'

/**
 * GA送信情報取得(設問)API
 * @param  {} params={}
 */
export const gaQaInfo = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  if (isFromAdminSystem()) {
    const newAxiosNoError = axiosNoError.create(NEW_API_CONFIG)
    return newAxiosNoError.post('/GA/001', r).catch(handleError)
  } else {
    const newAxios = axios.create(NEW_API_CONFIG)
    return newAxios.post('/GA/001', r).catch(handleError)
  }
}

/**
 * GA送信情報取得(最新ナレッジ)API
 * @param  {} params={}
 */
export const productCodes = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id
  
  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  if (isFromAdminSystem()) {
    const newAxiosNoError = axiosNoError.create(NEW_API_CONFIG)
    return newAxiosNoError.post('/GA/002', r).catch(handleError)
  } else {
    const newAxios = axios.create(NEW_API_CONFIG)
    return newAxios.post('/GA/002', r).catch(handleError)
  }
}
